module.exports = __webpack_public_path__ + "img/plat5.28680732.png";